<div class="history {{type}}">
  <ng-container *ngIf="!deviceService.isMobile(), else mobileCard">
  <div class="table-wrapper">
      <div class="header">
        <div class="cell date">{{'transaction-history.date' | customLocale}}</div>
        <div class="cell operation">{{'transaction-history.operation' | customLocale}}</div>
        <div class="cell amount">{{'transaction-history.amount' | customLocale}}</div>
        <div class="cell status">{{'transaction-history.status' | customLocale}}</div>
      </div>
    <div class="body" *ngIf="history">
      <div class="row" *ngFor="let operation of history; trackBy: trackByFn">
        <div class="cell date">
          {{getDateFromTransaction(operation.createdAt) | dfnsFormat: 'dd MMMM yyyy'}}<br>
          {{getDateFromTransaction(operation.createdAt) | dfnsFormat: 'HH:mm'}}
        </div>
        <div class="cell operation">
          <div class="title">
            <ng-container *ngTemplateOutlet="titleView; context: { operation }"></ng-container>
          </div>
          <div class="description">
            <ng-container *ngTemplateOutlet="descriptionView; context: { product: operation.product }"></ng-container>
          </div>
        </div>
        <div class="cell amount">
          {{formatAmount(operation)}}
        </div>
        <div class="cell status"><span class="completed">{{'transaction-history.statuses.completed' | customLocale}}</span></div>
      </div>
    </div>
  </div>
  </ng-container>

  <ng-template #mobileCard>
    <div class="mobile-list-wrapper" *ngIf="history">
      <div class="card" *ngFor="let operation of history; trackBy: trackByFn">
        <div class="line-1">
          <div class="data">
            <label>{{'transaction-history.date' | customLocale}}</label>
            <p class="date">
              {{getDateFromTransaction(operation.createdAt) | dfnsFormat: 'dd MMMM yyyy'}} {{getDateFromTransaction(operation.createdAt) | dfnsFormat: 'HH:mm'}}
            </p>
          </div>

          <div class="main-info">
            <div class="data">
              <label>{{'transaction-history.amount' | customLocale}}</label>
              <p class="amount">
                {{formatAmount(operation)}}
              </p>
            </div>
            <div class="data">
              <label>{{'transaction-history.status' | customLocale}}</label>
              <div class="status">
                <span class="completed">
                  {{'transaction-history.statuses.completed' | customLocale}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="line-2">
          <div class="data">
            <label>{{'transaction-history.operation' | customLocale}}</label>
            <div class="operation">
              <div class="title">
                <ng-container *ngTemplateOutlet="titleView; context:{ operation }"></ng-container>
              </div>
              <div class="description">
                <ng-container *ngTemplateOutlet="descriptionView; context: { product: operation.product }"></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
  </ng-template>
</div>

<ng-template #titleView  let-operation="operation">
  <p [innerHTML]="'transaction-history.types.' + getProductTypeTranslate(operation) | customLocale: {person: person(operation)}"></p>
  <ng-template [ngIf]="operation.account?.cardAccount">
    <span [routerLink]="'/me/finance/payment'"> ({{ 'transaction-history.card' | customLocale }} **** **** **** {{operation.account?.cardAccount?.label}})</span>
  </ng-template>
  <ng-template [ngIf]="operation.account?.bankAccount">
    <span [routerLink]="'/me/finance/payout'"> ({{ 'transaction-history.bank' | customLocale }} **** **** **** {{operation.account?.bankAccount?.label}})</span>
  </ng-template>
</ng-template>

<ng-template #descriptionView  let-product="product">
  <ng-template [ngIf]="product?.type ==='credits'" [ngIfElse]="noCredits">
    {{'transaction-history.count' | customLocale}} - {{product?.title}}Δ
  </ng-template>

  <ng-template #noCredits>
    <ng-template [ngIf]="product?.slug" [ngIfElse]="justTitle">
      <a [routerLink]="productLink(product)" target="_blank">
        {{product?.title}}
      </a>
    </ng-template>

    <ng-template #justTitle>
      {{product?.title}}
    </ng-template>
  </ng-template>
</ng-template>
